import React from 'react' // eslint-disable-line no-unused-vars
import Select from '../forms/Select'
import { connect } from 'react-redux'
import { validateField, submitForm } from '../pages/functions'
import { REPORT_TYPES, TET_REPORT_COUNTRIES } from '../constants'
import approve from 'approvejs'
import moment from 'moment'
import Datetime from 'react-datetime'
import { api } from './index.api'
import { addNotification as notify } from 'reapop'
import { CircularProgress } from '@material-ui/core'
import Footer from './Footer'
import InputGroup from '../forms/InputGroup'
import { cloneDeep } from 'lodash'

class Reports extends React.Component {
  constructor(props) {
    super(props)

    this._validate = this._validate.bind(this)

    this.state = {
      fields: cloneDeep(props.data.content.reportingFields),
      loading: false
    }
    this.data = []
    this.twoYearCutoff = moment().subtract(2, 'year').subtract(1, 'day')
    this.futureCutoff = moment().endOf('day')
  }

  _validate(e, field) {
    var fields = validateField(e, field, this.state.fields)
    this.setState({ fields })

    return false
  }

  _showNotification = (title, message, status) => {
    const { notify } = this.props
    notify({
      title,
      message,
      status,
      position: 'tr',
      dismissible: true,
      dismissAfter: 6000
    })
  }

  _isValidStartDate = (date) => {
    if (date.isBefore(this.twoYearCutoff) || date.isAfter(this.futureCutoff)) {
      return false
    }
    const endDate = this.state.fields.endDate.moment
    if (endDate) {
      if (date.isAfter(endDate)) {
        return false
      }
      if (Math.abs(date.diff(endDate, 'years')) >= 1) {
        return false
      }
    }
    return true
  }

  _isValidEndDate = (date) => {
    if (date.isBefore(this.twoYearCutoff) || date.isAfter(this.futureCutoff)) {
      return false
    }
    const startDate = this.state.fields.startDate.moment
    if (startDate) {
      if (date.isBefore(startDate)) {
        return false
      }
      if (Math.abs(date.diff(startDate, 'years')) >= 1) {
        return false
      }
    }
    return true
  }

  _onDateChange = (momentValue, field) => {
    if (!moment.isMoment(momentValue)) {
      return
    }
    const date = momentValue.format('YYYY-MM-DD')
    field.value = date
    field.moment = momentValue
    field.errors = []
    const result = approve.value(date, field.rules)
    if (result.errors.length > 0) {
      field.errors = Array.from(result.errors)
    }

    this.setState({
      fields: this.state.fields
    })
  }

  _isTETReportType = () => {
    return this.state.fields.reportType.value === 'TET_REPORTS'
  }

  _handleReportTypeChange = (value, field) => {
    // Clear country selection when switching away from TET
    if (this.state.fields.reportType.value === 'TET_REPORTS' && value !== 'TET_REPORTS') {
      // Add null check in case tetCountry field is not initialized
      if (this.state.fields.tetCountry) {
        this.state.fields.tetCountry.value = ''
        this.state.fields.tetCountry.errors = []
      }
    }
  }

  _submit(e) {
    this.data = []
    let { fields } = this.state
    fields = submitForm(e, fields)

    // Clear tetCountry errors if not TET report type (field is hidden)
    if (!this._isTETReportType() && fields.tetCountry) {
      fields.tetCountry.errors = []
    }

    for (var key in fields) {
      if (fields[key].errors.length > 0) {
        this.setState({ fields })
        return false
      }
    }

    // Conditional validation for TET Country
    if (this._isTETReportType() && !fields.tetCountry.value) {
      this._showNotification(
        'Error',
        'Please select a country for Temperature Excursion Tool report.',
        'error'
      )
      return false
    }

    this.setState({ loading: true, fields })
    const queryParams = {
      from: this.state.fields.startDate.moment.valueOf(),
      to: this.state.fields.endDate.moment.clone().endOf('day').valueOf(),
      type: this.state.fields.reportType.value
    }

    // Add country parameter for TET report type
    if (this._isTETReportType()) {
      queryParams.country = this.state.fields.tetCountry.value
    }

    api.fetchReportData(queryParams, this._getReportSuccessHandler.bind(this), this._getReportErrorHandler.bind(this))
  }

  _getReportSuccessHandler = response => {
    if (!response.ok) {
      this._getReportErrorHandler()
      return
    }

    response.json().then(pagedData => {
      this.data = this.data.concat(pagedData.content)
      if (pagedData.last) {
        this._downloadAccumulatedReportContent(this.data)
      } else {
        const queryParams = {
          from: this.state.fields.startDate.moment.valueOf(),
          to: this.state.fields.endDate.moment.clone().endOf('day').valueOf(),
          type: this.state.fields.reportType.value,
          page: pagedData.number + 1
        }
        // Add country parameter for TET report type in pagination
        if (this._isTETReportType()) {
          queryParams.country = this.state.fields.tetCountry.value
        }
        api.fetchReportData(queryParams, this._getReportSuccessHandler.bind(this), this._getReportErrorHandler.bind(this))
      }
    })
  }

  _getReportErrorHandler = (error) => {
    this._showNotification('Error', 'There seems to be an error at our server side. Please try again later.', 'error')
    this.setState({ loading: false })
    this.data = []
  }

  _downloadAccumulatedReportContent = data => {
    const languageContent = this.props.data.content

    if (data.length > 0) {
      const reportHeaders = Object.getOwnPropertyNames(data[0])
      var json2csv = require('json2csv')
      var csv = json2csv({ data, fields: reportHeaders })

      // Add UTF-8 BOM for TET reports to fix encoding issues with special characters (°C/°F)
      if (this._isTETReportType()) {
        csv = '﻿' + csv
      }

      var fileDownload = require('react-file-download')
      fileDownload(csv, 'Report.csv')
    } else {
      this._showNotification(languageContent.noDataFound, languageContent.noDataMessage, 'info')
    }
    this.setState({ loading: false })
  }

  render() {
    const languageContent = this.props.data.content
    const fields = this.state.fields
    return (
      <div className='page-container'>
        <div className='page-content'>
          <div className='widget-mb-0-row'>
            <form
              onSubmit={e => {
                e.preventDefault()
                this._submit(e)
              }}
            >
              <div className='container'>
                <div className='row'>
                  <div className='col-12'>
                    <h3 className='mb-3 header-primary'>{languageContent.reportGen}</h3>
                    <p>{languageContent.reportGenMessage}</p>
                    <p>{languageContent.reportPeriodDisclosure}</p>
                  </div>
                </div>
                <div className='row m-t-10'>
                  <div className='col-lg-4 mt-3'>
                    <Select
                      searchable
                      clearable
                      options={REPORT_TYPES}
                      field={fields.reportType}
                      fields={fields}
                      onChange={this._handleReportTypeChange}
                      validate={(e) => this._validate(e, fields.reportType)}
                    />
                  </div>
                  {this._isTETReportType() && (
                    <div className='col-lg-4 mt-3'>
                      <Select
                        searchable
                        clearable
                        options={TET_REPORT_COUNTRIES}
                        field={fields.tetCountry}
                        fields={fields}
                        validate={(e) => this._validate(e, fields.tetCountry)}
                      />
                    </div>
                )}
                  <div className='col-lg-4 mt-3'>
                    <Datetime
                      closeOnSelect
                      dateFormat='YYYY-MM-DD'
                      timeFormat={false}
                      renderInput={(_props, openCalendar, _closeCalendar) =>
                        getCalendarInputGroup(openCalendar, fields.startDate)
                      }
                      onChange={moment => this._onDateChange(moment, fields.startDate)}
                      isValidDate={this._isValidStartDate}
                    />
                  </div>
                  <div className='col-lg-4 mt-3'>
                    <Datetime
                      closeOnSelect
                      dateFormat='YYYY-MM-DD'
                      timeFormat={false}
                      renderInput={(_props, openCalendar, _closeCalendar) =>
                        getCalendarInputGroup(openCalendar, fields.endDate)
                      }
                      onChange={moment => this._onDateChange(moment, fields.endDate)}
                      isValidDate={this._isValidEndDate}
                    />
                  </div>
                </div>
                <div className='row'>
                </div>
                <div className='row m-t-10'>
                  <div className='col mt-4 m-b-10 text-right'>
                    <button type='submit' className='btn btn-info btn-lg-wide search-button btn-rounded' >
                      {
                        this.state.loading
                          ? <div className='loading-text-centered'>
                            <span>{languageContent.GenerateRep}</span>
                            <span className='loading-progress-centered'><CircularProgress size={24} /></span>
                          </div>
                          : <React.Fragment>{languageContent.GenerateRep}</React.Fragment>
                      }
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

const getCalendarInputGroup = (openCalendar, field) =>
  <InputGroup
    searchable={false}
    clearable={false}
    field={field}
    validate={() => true}
    onFocus={openCalendar}
    readonly
  />

function mapStateToProps(state) {
  return {
    fields: state.fields,
    data: state.pageContent
  }
}

export default connect(mapStateToProps, { notify })(Reports)



// WEBPACK FOOTER //
// ./src/mi-app/Reports.js